import { Link, useLocation } from "react-router-dom";
import { Car, KeyRound } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ModeSwitcher({ className = "", size = "sm" }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const hosting = pathname.startsWith("/host");
  const pad = size === "lg" ? "px-4 py-2 text-sm" : "px-3 py-1.5 text-xs";
  const item = (active) => `${pad} rounded-full font-semibold inline-flex items-center gap-1.5 transition-colors ${active ? "bg-white text-blue-600 shadow-sm" : "text-slate-500 hover:text-slate-700"}`;
  return (
    <div data-testid="mode-switcher" className={`inline-flex items-center bg-slate-100 rounded-full p-1 ${className}`}>
      <Link to="/account" data-testid="mode-renting" className={item(!hosting)}><Car size={14} /> {t("nav.renting")}</Link>
      <Link to="/host/dashboard" data-testid="mode-hosting" className={item(hosting)}><KeyRound size={14} /> {t("nav.hosting")}</Link>
    </div>
  );
}
